<template>
    <div>
        <template v-if="!hideLabel">
            <div class="text-14 font-normal text-black mb-2.5">
                {{ inputLbl.name }}
            </div>
        </template>
        <div class="relative pb-5">
            <input type="tel" class="w-full bg-white px-4 py-1 rounded-full border text-14 h-10 font-normal text-black"
                :class="[isError ? 'border-red-500' : isDisable ? 'border-a-gray-a8a8a8 bg-a-gray-e5e5e5' : 'border-a-gray-a8a8a8 placeholder-a-gray-a8a8a8']"
                v-model="content" :placeholder="!isError ? inputLbl.placeholder : ''" :maxlength="inputMaxLength" :readonly="isDisable"
                @input="onChange()" @blur="onBlur" autocomplete="off">
            <div class="text-red-500 w-full text-12 font-normal text-right" :class="[errorAppend ? 'pt-1':'absolute bottom-0 left-0']" v-if="isError">
                {{ getErrorMsg }}
            </div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputNationalId",
    props: {
        // v-model
        inputValue: { type: String },
        // props
        errorInfo: { type: Object, required: true },
        isShowError: { type: Boolean, default: false },
        isSubmitted: { type: Boolean, default: false },
        // text
        inputLbl: { type: Object, required: true },
        hideLabel: { type: Boolean },
        delimeter: { type: String, default: '-' },
        showErrorOnBlur: { type: Boolean },
        errorAppend: { type: Boolean },
        isDisable: {type: Boolean, default: false}
    },
    data: function () {
        return {
            content: this.inputValue,
            inputMaxLength: 17,
            inputMinLength: 17,
            errorRequired: false,
            isTouched: false
        };
    },
    computed: {
        isError: function () {
            if (this.isDisable) return;
            
            if (this.showErrorOnBlur == true && !this.isSubmitted) {
                return this.isShowError && !this.errorInfo.isValid && this.isTouched
            }
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function () {
            return this.isError
                ? this.errorInfo.msg
                : '';
        }
    },
    created: function () {
        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function () {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            this.errorRequired = false
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                this.errorRequired = true
                return;
            }
            // too short
            if (this.inputLbl.too_short && (this.content.length < this.inputMinLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.inputMinLength));
                return;
            }
            // invalid format
            if (this.inputLbl.invalid && this.content) {
                if (!Util.isNationalIdCard(RegxHelper.removeNotNumber(this.content))) {
                    this.errorInfo.setValid(false);
                    this.errorInfo.setMsg(this.inputLbl.invalid);
                    return;
                }
            }
        },
        onChange: function () {
            let result = this.content;
            result = RegxHelper.removeNotNumber(result);
            let input = result

            let n1, n2, n3, n4, n5;
            if (input.length <= 1) {
                // do nothing
            } else if (input.length <= 5) {
                n1 = input.substring(0, 1);
                n2 = input.substring(1, 5);
                input = n1 + this.delimeter + n2;
            } else if (input.length <= 10) {
                n1 = input.substring(0, 1);
                n2 = input.substring(1, 5);
                n3 = input.substring(5, 11)
                input = n1 + this.delimeter + n2 + this.delimeter + n3;
            } else if (input.length <= 12) {
                n1 = input.substring(0, 1);
                n2 = input.substring(1, 5);
                n3 = input.substring(5, 10)
                n4 = input.substring(10, 12)
                input = n1 + this.delimeter + n2 + this.delimeter + n3 + this.delimeter + n4;
            } else {
                n1 = input.substring(0, 1);
                n2 = input.substring(1, 5);
                n3 = input.substring(5, 10)
                n4 = input.substring(10, 12)
                n5 = input.substring(12)
                input = n1 + this.delimeter + n2 + this.delimeter + n3 + this.delimeter + n4 + this.delimeter + n5;
            }

            this.content = input;
            this.validateInput();
            this.$emit('update:inputValue', result);
        },
        onBlur: function () {
            if (this.showErrorOnBlur == true) {
                if (!this.isTouched) {
                    this.isTouched = true
                }
                this.validateInput()
            }
        }
    },
}
</script>

